import { LegalLayout, LegalSection } from "./LegalLayout";
import { SITE } from "../../lib/site";
import { openCookieSettings } from "../../lib/consent";

const UPDATED = "august 2026";

export const PoliticaConfidentialitate = () => (
  <LegalLayout kicker="Informații legale" title="Politica de Confidențialitate" updated={UPDATED} testid="privacy-page">
    <LegalSection title="1. Cine suntem — operatorul datelor" testid="privacy-operator">
      <p>
        Operatorul datelor cu caracter personal este <strong className="text-slate-900">{SITE.name}</strong>, școală de șoferi cu sediul în {SITE.address}.
      </p>
      <p>
        Ne poți contacta oricând la telefon <a href={`tel:${SITE.phoneRaw}`} className="text-[#1565C0] hover:text-[#0D47A1] transition-colors">{SITE.phoneDisplay}</a> sau prin email la{" "}
        <a href={`mailto:${SITE.email}`} className="text-[#1565C0] hover:text-[#0D47A1] transition-colors">{SITE.email}</a> pentru orice aspect legat de datele tale personale.
      </p>
    </LegalSection>

    <LegalSection title="2. Ce date colectăm" testid="privacy-data">
      <p>Colectăm doar datele strict necesare pentru a răspunde solicitărilor tale:</p>
      <ul className="list-disc pl-5 space-y-1.5">
        <li><strong className="text-slate-900">Nume și prenume</strong> — completat de tine în formularul de contact;</li>
        <li><strong className="text-slate-900">Număr de telefon</strong> — pentru a te contacta în legătură cu înscrierea;</li>
        <li><strong className="text-slate-900">Conținutul mesajului</strong> — informațiile pe care alegi să ni le transmiți;</li>
        <li><strong className="text-slate-900">Date tehnice minime</strong> — preferințe de afișare salvate local în browserul tău (nu sunt transmise către noi).</li>
      </ul>
    </LegalSection>

    <LegalSection title="3. Formularul de contact" testid="privacy-form">
      <p>
        Formularul de contact de pe acest site <strong className="text-slate-900">nu stochează datele tale pe serverele noastre</strong>. La trimitere, formularul deschide aplicația WhatsApp cu mesajul completat de tine, iar transmiterea se face direct prin contul tău de WhatsApp.
      </p>
      <p>Folosim aceste date exclusiv pentru a te contacta și a-ți oferi informații despre serviciile școlii de șoferi.</p>
    </LegalSection>

    <LegalSection title="4. WhatsApp" testid="privacy-whatsapp">
      <p>
        Dacă alegi să ne contactezi prin WhatsApp, conversația este procesată de platforma WhatsApp (Meta Platforms, Inc.) conform propriei politici de confidențialitate. Îți recomandăm să consulți politica de confidențialitate WhatsApp pentru detalii despre modul în care platforma îți procesează datele.
      </p>
      <p>Păstrăm conversațiile doar atât cât este necesar pentru gestionarea solicitării tale și a relației contractuale ulterioare.</p>
    </LegalSection>

    <LegalSection title="5. Email și telefon" testid="privacy-email-phone">
      <p>
        Datele transmise prin email sau telefon sunt folosite exclusiv pentru comunicarea cu tine: oferirea de informații, programarea orelor, întocmirea dosarului de înscriere și îndeplinirea obligațiilor legale specifice activității de școală de șoferi.
      </p>
    </LegalSection>

    <LegalSection title="6. Temeiul legal și scopurile prelucrării" testid="privacy-legal-basis">
      <p>Prelucrăm datele tale în baza:</p>
      <ul className="list-disc pl-5 space-y-1.5">
        <li><strong className="text-slate-900">Consimțământului tău</strong> (art. 6 alin. (1) lit. a GDPR) — bifat în formularul de contact;</li>
        <li><strong className="text-slate-900">Demersurilor precontractuale</strong> (art. 6 alin. (1) lit. b GDPR) — pentru a-ți oferi informații și a pregăti înscrierea;</li>
        <li><strong className="text-slate-900">Obligațiilor legale</strong> (art. 6 alin. (1) lit. c GDPR) — documentele necesare dosarului de școlarizare, conform legislației rutiere în vigoare.</li>
      </ul>
    </LegalSection>

    <LegalSection title="7. Durata stocării" testid="privacy-retention">
      <p>
        Datele transmise prin formular, email sau telefon sunt păstrate maximum <strong className="text-slate-900">24 de luni</strong> de la ultima comunicare, cu excepția cazului în care devii elev al școlii — situație în care datele din dosarul de școlarizare sunt păstrate conform termenelor legale aplicabile.
      </p>
      <p>Preferințele salvate în browser (cookie-uri necesare) rămân pe dispozitivul tău până le ștergi sau până la expirarea lor.</p>
    </LegalSection>

    <LegalSection title="8. Drepturile tale" testid="privacy-rights">
      <p>Conform GDPR, ai următoarele drepturi:</p>
      <ul className="list-disc pl-5 space-y-1.5">
        <li>Dreptul de acces la datele tale;</li>
        <li>Dreptul la rectificarea datelor inexacte;</li>
        <li>Dreptul la ștergerea datelor („dreptul de a fi uitat");</li>
        <li>Dreptul la restricționarea prelucrării;</li>
        <li>Dreptul la portabilitatea datelor;</li>
        <li>Dreptul de opoziție la prelucrare;</li>
        <li>Dreptul de a-ți retrage consimțământul în orice moment, fără a afecta legalitatea prelucrării anterioare.</li>
      </ul>
      <p>
        Pentru exercitarea acestor drepturi, scrie-ne la{" "}
        <a href={`mailto:${SITE.email}`} className="text-[#1565C0] hover:text-[#0D47A1] transition-colors">{SITE.email}</a>. Ai, de asemenea, dreptul de a depune o plângere la{" "}
        <strong className="text-slate-900">Autoritatea Națională de Supraveghere a Prelucrării Datelor cu Caracter Personal (ANSPDCP)</strong> — www.dataprotection.ro.
      </p>
    </LegalSection>

    <LegalSection title="9. Contact GDPR" testid="privacy-contact">
      <p>
        Pentru orice întrebare privind protecția datelor tale personale, ne poți contacta la{" "}
        <a href={`mailto:${SITE.email}`} className="text-[#1565C0] hover:text-[#0D47A1] transition-colors">{SITE.email}</a> sau la telefon{" "}
        <a href={`tel:${SITE.phoneRaw}`} className="text-[#1565C0] hover:text-[#0D47A1] transition-colors">{SITE.phoneDisplay}</a>.
      </p>
    </LegalSection>
  </LegalLayout>
);

export const PoliticaCookies = () => (
  <LegalLayout kicker="Informații legale" title="Politica Cookies" updated={UPDATED} testid="cookies-page">
    <LegalSection title="1. Ce sunt cookie-urile" testid="cookies-what">
      <p>
        Cookie-urile sunt fișiere mici de text (sau înregistrări similare în spațiul de stocare al browserului) salvate pe dispozitivul tău atunci când vizitezi un site. Ele permit site-ului să funcționeze corect și să își amintească preferințele tale.
      </p>
    </LegalSection>

    <LegalSection title="2. Tipurile de cookie-uri utilizate" testid="cookies-types">
      <p>Acest site folosește două categorii:</p>
      <ul className="list-disc pl-5 space-y-1.5">
        <li><strong className="text-slate-900">Cookie-uri strict necesare</strong> — fără ele site-ul nu poate funcționa corect. Nu necesită consimțământ.</li>
        <li><strong className="text-slate-900">Cookie-uri de analiză</strong> — ne ajută să înțelegem cum este utilizat site-ul. Sunt activate <strong className="text-slate-900">doar cu acordul tău explicit</strong>.</li>
      </ul>
    </LegalSection>

    <LegalSection title="3. Cookie-uri necesare" testid="cookies-necessary">
      <p>Acestea sunt stocate local în browserul tău și nu sunt transmise către terți:</p>
      <div className="overflow-x-auto">
        <table className="w-full text-sm mt-2">
          <thead>
            <tr className="text-left text-slate-300 border-b border-white/10">
              <th className="py-2 pr-4 font-semibold">Nume</th>
              <th className="py-2 pr-4 font-semibold">Scop</th>
              <th className="py-2 font-semibold">Durată</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100">
            <tr>
              <td className="py-2.5 pr-4 font-semibold text-[#1565C0]">avd_cookie_consent</td>
              <td className="py-2.5 pr-4">Reține alegerea ta privind cookie-urile</td>
              <td className="py-2.5">Permanentă (până la ștergere)</td>
            </tr>
            <tr>
              <td className="py-2.5 pr-4 font-semibold text-[#1565C0]">avd_promo_until</td>
              <td className="py-2.5 pr-4">Reține închiderea bănnerului promoțional</td>
              <td className="py-2.5">24 de ore</td>
            </tr>
          </tbody>
        </table>
      </div>
    </LegalSection>

    <LegalSection title="4. Cookie-uri de analiză" testid="cookies-analytics">
      <p>
        În prezent, acest site <strong className="text-slate-900">nu folosește cookie-uri de analiză</strong>. Dacă în viitor vom integra un serviciu de analiză (de exemplu Google Analytics), acesta va fi activat numai după ce îți dai acordul din bannerul de cookie-uri sau din pagina de preferințe.
      </p>
    </LegalSection>

    <LegalSection title="5. Cum poți dezactiva cookie-urile" testid="cookies-disable">
      <p>
        Poți șterge sau bloca cookie-urile oricând din setările browserului tău (Chrome, Firefox, Safari, Edge — secțiunea „Confidențialitate și securitate"). Reține că blocarea cookie-urilor necesare poate afecta funcționarea corectă a site-ului.
      </p>
    </LegalSection>

    <LegalSection title="6. Modificarea preferințelor" testid="cookies-preferences">
      <p>Îți poți schimba oricând alegerea privind cookie-urile de analiză:</p>
      <button
        onClick={openCookieSettings}
        data-testid="cookies-open-settings-btn"
        className="inline-flex items-center gap-2 bg-[#1565C0] hover:bg-[#0D47A1] text-white rounded-full px-6 py-3 text-sm font-semibold transition-colors"
      >
        Modifică preferințele cookie
      </button>
    </LegalSection>
  </LegalLayout>
);

export const TermeniConditii = () => (
  <LegalLayout kicker="Informații legale" title="Termeni și Condiții" updated={UPDATED} testid="terms-page">
    <LegalSection title="1. Informații generale" testid="terms-general">
      <p>
        Acest site este operat de <strong className="text-slate-900">{SITE.name}</strong>, școală de șoferi din {SITE.city}, cu sediul în {SITE.address}. Prin accesarea și utilizarea site-ului, accepți termenii și condițiile de mai jos.
      </p>
      <p>
        Informațiile prezentate pe site au caracter general și informativ, referitor la serviciile de pregătire pentru obținerea permisului de conducere categoria B.
      </p>
    </LegalSection>

    <LegalSection title="2. Utilizarea site-ului" testid="terms-usage">
      <p>Te angajezi să folosești acest site în mod legal și corect. Nu este permisă:</p>
      <ul className="list-disc pl-5 space-y-1.5">
        <li>Utilizarea site-ului în scopuri ilegale sau frauduloase;</li>
        <li>Încercarea de a accesa neautorizat sistemele sau datele site-ului;</li>
        <li>Copierea sau redistribuirea conținutului fără acordul nostru scris;</li>
        <li>Transmiterea de conținut fals, defăimător sau dăunător prin formularul de contact.</li>
      </ul>
    </LegalSection>

    <LegalSection title="3. Serviciile prezentate" testid="terms-services">
      <p>
        Prețurile, promoțiile (inclusiv reducerea de 20% pentru elevi, studenți, pensionari și șomeri) și disponibilitatea programelor sunt informative și pot fi modificate. Oferta contractuală fermă se stabilește exclusiv la înscriere, prin contractul de școlarizare semnat cu școala.
      </p>
      <p>Trimiterea formularului de contact sau a unui mesaj pe WhatsApp nu reprezintă o înscriere fermă și nu generează obligații contractuale pentru nicio parte.</p>
    </LegalSection>

    <LegalSection title="4. Limitarea răspunderii" testid="terms-liability">
      <p>
        Depunem toate eforturile ca informațiile de pe site să fie corecte și actualizate, însă nu garantăm absența erorilor. Nu ne asumăm răspunderea pentru:
      </p>
      <ul className="list-disc pl-5 space-y-1.5">
        <li>Decizii luate pe baza informațiilor informative de pe site, fără confirmare directă;</li>
        <li>Funcționarea serviciilor terțe (WhatsApp, Google Maps, Facebook) către care site-ul face trimitere;</li>
        <li>Întreruperi temporare de funcționare a site-ului.</li>
      </ul>
    </LegalSection>

    <LegalSection title="5. Proprietate intelectuală" testid="terms-ip">
      <p>
        Toate elementele site-ului — texte, design, fotografii, logo și materiale grafice — aparțin {SITE.name} sau sunt utilizate cu acordul titularilor. Sunt protejate de legislația privind drepturile de autor și nu pot fi reproduse fără acordul nostru scris.
      </p>
    </LegalSection>

    <LegalSection title="6. Legislația aplicabilă" testid="terms-law">
      <p>
        Acești termeni sunt guvernați de legislația română. Orice litigiu va fi soluționat pe cale amiabilă sau, în caz contrar, de instanțele competente din România.
      </p>
    </LegalSection>

    <LegalSection title="7. Contact" testid="terms-contact">
      <p>
        Pentru întrebări legate de acești termeni, ne poți contacta la{" "}
        <a href={`mailto:${SITE.email}`} className="text-[#1565C0] hover:text-[#0D47A1] transition-colors">{SITE.email}</a>, la telefon{" "}
        <a href={`tel:${SITE.phoneRaw}`} className="text-[#1565C0] hover:text-[#0D47A1] transition-colors">{SITE.phoneDisplay}</a> sau la adresa {SITE.address}.
      </p>
    </LegalSection>
  </LegalLayout>
);
